import { render, staticRenderFns } from "./configuracoestiss.vue?vue&type=template&id=25a4ad94&"
import script from "./configuracoestiss.vue?vue&type=script&lang=js&"
export * from "./configuracoestiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports